import React from "react";
import { Button, Card } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor, getIsAdmin } from "@icarius-app/selectors";
import Counter from "@icarius-common/counter";
import { getLocalizedString } from "@icarius-localization/strings";
import ActivitySelection from "./activitySelection";

const Sidebar = (props) => {
    const { trainingData, selectedActivityId, handleShowParticipants } = props;

    const isAdmin = useSelector(getIsAdmin);
    const color = useSelector(getAppColor);

    return (
        <Card
            style={{
                margin: 8,
                padding: 15,
                borderRadius: 15,
                width: "100%",
                overflow: "auto",
                display: "flex",
                flexDirection: "column",
                gap: 22,
            }}
        >
            {(trainingData.isInstructor || isAdmin) && (
                <Button
                    variant="contained"
                    onClick={() => handleShowParticipants(trainingData.id)}
                    className="whiteText"
                    style={{ background: color, border: 0 }}
                >
                    <span style={{ display: "flex", gap: 10 }}>
                        {getLocalizedString("viewParticipants")}{" "}
                        <Counter value={trainingData.participantsAmount || 0} />
                    </span>
                </Button>
            )}
            <ActivitySelection trainingData={trainingData} selectedActivityId={selectedActivityId} />
        </Card>
    );
};

export default Sidebar;
